import script from "./get-past.vue?vue&type=script&setup=true&lang=js"
export * from "./get-past.vue?vue&type=script&setup=true&lang=js"

import "./get-past.vue?vue&type=style&index=0&id=38043573&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38043573"]])

export default __exports__